/*
    ───────────────────────────────────────
    ────── Tips and tricks Carousel ───────
    ───────────────────────────────────────
*/
const initTipsCarousel = () => {
    const track = document.getElementById( 'tipsTrack' );
    if ( !track ) return; // Exit if the carousel is not present

    const prev   = document.getElementById( 'tipsPrev' );
    const next   = document.getElementById( 'tipsNext' );
    const status = document.getElementById( 'tipsStatus' );
    const dots   = document.querySelectorAll( '.tips-carousel__dot' );
    const total  = track.children.length;
    let current  = 0;

    function goTo(index) {
        current = index;
        track.style.transform = `translateX(-${current * 100}%)`;
        prev.disabled = current === 0;
        next.disabled = current === total - 1;
        status.textContent = `${current + 1} / ${total}`;
        dots.forEach((dot, i) =>
            dot.setAttribute('aria-selected', i === current ? 'true' : 'false')
        );
    }

    prev.addEventListener( 'click', () => { if ( current > 0 ) goTo( current - 1 ); });
    next.addEventListener( 'click', () => { if ( current < total - 1 ) goTo( current + 1 ); });
    dots.forEach(dot => dot.addEventListener( 'click', () => goTo( +dot.dataset.index ) ));

    document.getElementById( 'tipsCarousel' ).addEventListener( 'keydown', (e) => {
        if ( e.key === 'ArrowLeft' && current > 0 ) goTo( current - 1 );
        if ( e.key === 'ArrowRight' && current < total - 1 ) goTo( current + 1 );
    });

    goTo(0);
}

export default initTipsCarousel;